var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineAiRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 195,
    viewBox: "0 0 251 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10 163.949C205.539 177.694 184.835 217.556 97.4173 130.043C10 42.5307 0.798178 18.7054 166.891 80.1017C332.984 141.498 170.112 78.2689 155.389 10",
    stroke: "#091C00",
    strokeWidth: 20,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAiRanking);
export default __webpack_public_path__ + "static/media/line_ai_ranking.a88c496888713542c54817000c90edbf.svg";
export { ForwardRef as ReactComponent };